var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.topright",modifiers:{"hover":true,"topright":true}}],staticClass:"tooltip-icon",class:_vm.shade,attrs:{"title":_vm.title}},[_vm._v("?")])}
var staticRenderFns = []

export { render, staticRenderFns }